import { Box, Divider, Paper } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import React from "react";

interface StatusChangePopoverProps {
  size: "small" | "medium" | "full";
  header: React.ReactNode;
  content: React.ReactNode;
  actions: React.ReactNode;
  dialogHeight: number; // needed to restrict small popover
  dialogWidth: number;
}

const StatusChangePopover: React.FC<StatusChangePopoverProps> = ({
  size,
  header,
  content,
  actions,
  dialogHeight,
  dialogWidth,
}) => {
  const isSmall = size === "small";
  const isMedium = size === "medium";

  const wrapperStyle: SxProps<Theme> = (isSmall || isMedium) ? {
      // SMALL Mode
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      minWidth: isSmall ? 280 : dialogWidth < 900 ? `${dialogWidth - 48}px` : 900,
      maxWidth: isSmall ?
        dialogWidth < 444 ?
          `${dialogWidth - 48}px` : 444
        : `${dialogWidth - 48}px`,
      maxHeight: dialogHeight - 48 > 0 ? dialogHeight - 48 : "100%",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }
    : {
      // FULL Mode
      position: "absolute",
      top: "150px",
      left: "24px",
      right: "24px",
      bottom: "24px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    };

  const styles = {
    header: {
      padding: "45px",
      paddingBottom: "0px",
    },
    contentWrapper: {
      overflowY: "auto" as const,
      padding: "16px 45px",
      flexGrow: 1,
    },
    divider: {
      position: "sticky" as const,
      bottom: 0,
      backgroundColor: "#e0e0e0",
      zIndex: 1,
    },
    actions: {
      padding: "24px 45px",
    },
  };

  return (
    <Paper sx={wrapperStyle} elevation={8}>
      <Box sx={styles.header}>{header}</Box>

      <Box sx={styles.contentWrapper}>{content}</Box>

      {!isSmall && (<Divider sx={styles.divider} />)}

      <Box sx={styles.actions}>{actions}</Box>
    </Paper>
  );
};

export default StatusChangePopover;
